import "../../../../src/pages/styles/main.css";
import ToolBar from "../../../../src/pages/why-build/toolbar.md";
import GetAnOverview from "../../../../src/pages/why-build/get-an-overview.md";
import bgImg from "../../../../src/pages/images/Summary_BgImage.jpg";
import heroVideo from "../../../../src/pages/videos/R2_Add-on_why-build.mp4";
import * as React from 'react';
export default {
  ToolBar,
  GetAnOverview,
  bgImg,
  heroVideo,
  React
};